import type { IconProps } from "../types";

/**
 * TowelRack: タオル掛けアイコン。lucide-react に存在しないため registry svgContent を逐語再現。
 */
export const TowelRack = ({
	size = 24,
	color = "currentColor",
	strokeWidth = 2,
	className,
	"aria-label": ariaLabel,
}: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 24 24"
		fill="none"
		stroke={color}
		strokeWidth={strokeWidth}
		strokeLinecap="round"
		strokeLinejoin="round"
		className={className}
		role={ariaLabel ? "img" : undefined}
		aria-label={ariaLabel}
		aria-hidden={ariaLabel ? undefined : true}
	>
		<path d="M22 7h-2" />
		<path d="M6.5 3h11A2.5 2.5 0 0 1 20 5.5V20a1 1 0 0 1-1 1h-9a1 1 0 0 1-1-1V5.5a1 1 0 0 0-5 0V17a1 1 0 0 0 1 1h4" />
		<path d="M9 7H2" />
	</svg>
);
